;(function ( $ ) {

    /**
     *  guidedTourImage
     *  set fill color for SVGs
     **/

    'use strict';

    // Create the defaults once
    var pluginName = 'guidedTourImage';
    var defaults = {
    };

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function () {
            $(document).ready(function() {
                //load the svg's and rewrite the img tag to use the svg inline and use color/tint with css fills
                $('.tour-image').each(function() {
                    var $img = jQuery(this);
                    var imgURL = $img.attr('src');
                    var attributes = $img.prop("attributes");

                    $.get(imgURL, function(data) {
                        // Get the SVG tag, ignore the rest
                        var $svg = jQuery(data).find('svg');

                        // Remove any invalid XML tags
                        $svg = $svg.removeAttr('xmlns:a');

                        // Loop through IMG attributes and apply on SVG
                        $.each(attributes, function() {
                            $svg.attr(this.name, this.value);
                        });

                        // Replace IMG with SVG
                        $img.replaceWith($svg);
                    }, 'xml');
                });
            });
        }
    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
